<!-- 图片列表 -->
<template>
  <div>
    <div class="container-1600 pt-[35px]">
      <div class="flex items-center">
        <span>当前位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="!text-[16px]">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>风采一览</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="-mx-[15px] mt-[35px] flex flex-wrap">
        <div
          class="h-[224px] w-[25%] px-[15px] pb-[30px] lt-lg:w-[50%]"
          v-for="(item, index) in imgList.list"
          :key="index"
        >
          <ListImgCard :detail="item" />
        </div>
      </div>
      <div class="mt-[40px] text-center">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :total="imgList.total"
          :page-size="imgList.pageSize"
          @current-change="handlePageChange"
          class="inline-block"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/tool';
import BannerJoinUs from '@/components/BannerJoinUs.vue';
import ListImgCard from '@/components/ListImgCard.vue';
import { imgList } from '@/api/article';

export default {
  name: 'ListImg',
  components: {
    BannerJoinUs,
    ListImgCard,
  },
  data() {
    return {
      imgList: {
        total: 0,
        currentPage: 1,
        pageSize: 8,
        list: [
          {
            image_id: '',
            title: '',
            pic: '',
            status: '',
            create_time: '',
            update_time: '',
            sortid: '',
            author: '',
          },
        ],
      },
    };
  },
  methods: {
    getData() {
      imgList({ limit: this.imgList.pageSize, page: this.imgList.currentPage }).then((res) => {
        const data = res.data.list;
        data.map((item) => {
          item.create_time = formatDate(item.create_time, 'YYYY-MM-DD');
          return item;
        });
        this.imgList.list = data;
        this.imgList.total = res.data.count;
      });
    },
    handlePageChange(currentPage) {
      this.imgList.currentPage = currentPage;
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
